/**
 * Contenido de "Help & Support" (ACHIEVERY-1363, Etapa 5). Solo código (no Prismic).
 * Contenido GLOBAL (igual para todos los centros). Editable a mano.
 *
 * videos: { id, title, duration, platform, type: 'jwplayer'|'youtube', videoId }
 *   -> abren el VideoModal agnóstico (mismo de la Etapa 1). `id` es el mismo en los dos
 *      idiomas (identifica el video, no el asset). `platform` se muestra junto a la duración.
 * faqs:   { q, a } -> `a` es HTML (se renderiza con v-html); admite <ul>, <strong> y <a>.
 */
export default {
  'en-us': {
    videos: [
      { id: 'meet-achievery', title: 'Meet The Achievery', duration: '1:05', platform: 'The Achievery', type: 'jwplayer', videoId: 'AY52zL4d' },
      { id: 'create-account', title: 'How to create your free account', duration: '1:55', platform: 'The Achievery', type: 'jwplayer', videoId: '393TJvCC' },
      { id: 'what-you-find', title: 'What can you find at The Achievery', duration: '1:49', platform: 'The Achievery', type: 'jwplayer', videoId: 'Rcvh9kv8' },
      { id: 'meet-career-village', title: 'Meet Career Village', duration: '2:07', platform: 'Career Village', type: 'jwplayer', videoId: 'EYDDD3E8' }
    ],
    faqs: [
      {
        q: 'What is a Connected Learning Center?',
        a: 'A Connected Learning Center is a free community space hosted by local organizations in partnership with AT&amp;T that offers high-speed internet, modern computers, and digital skills training to help students, adults, caregivers, and older Americans thrive in today’s digital world.'
      },
      {
        q: 'Who can use a Connected Learning Center?',
        a: 'CLCs are open to everyone in the community free of charge. Whether you’re a student working on homework, an adult building new job skills, or someone learning to use a smartphone for the first time, there’s a place for you.'
      },
      {
        q: 'What kind of resources are available at a CLC?',
        a: 'Each Connected Learning Center offers high-speed internet, access to modern devices, and hands-on digital skills training from smartphone basics to essential computer skills.'
      },
      {
        q: 'Where can I find more information or locate a CLC near me?',
        a: 'Visit <a href="https://sustainability.att.com/cr/cl-centers" target="_blank" rel="noopener noreferrer">sustainability.att.com/cr/cl-centers</a> to find the Connected Learning Center closest to you, along with hours, contact details, and available programs.'
      },
      {
        q: 'What learning platforms can I access at a CLC?',
        a: 'Depending on your needs, you can get started with:'
          + '<ul>'
          + '<li><strong>ScreenReady®</strong> - resources for parents and caregivers on online safety and digital skills</li>'
          + '<li><strong>The Achievery</strong> - learning platform for K-12 students</li>'
          + '<li><strong>CareerVillage</strong> - career mentoring for high school and college students</li>'
          + '</ul>'
      },
      {
        q: 'How can I stay up to date with all CLC updates?',
        a: 'It’s easy! Just go to the “Stay in the loop” section, enter your email address, select your center, and click Subscribe. You’ll get all the relevant updates: invitations, resources, and more, straight to your inbox.'
      },
      {
        q: 'What is ScreenReady?',
        a: 'ScreenReady is an AT&amp;T initiative focused on family digital wellbeing, providing resources, tips and tools to help you and your family build confidence using technology, practice healthy digital habits and fully participate in today’s connected world.'
      }
    ]
  },
  'es-es': {
    videos: [
      { id: 'meet-achievery', title: 'Conoce The Achievery', duration: '1:07', platform: 'The Achievery', type: 'jwplayer', videoId: 'kZRLx0Hn' },
      { id: 'create-account', title: 'Cómo crear tu cuenta gratuita en The Achievery', duration: '1:49', platform: 'The Achievery', type: 'jwplayer', videoId: 'IpYXcMw5' },
      { id: 'what-you-find', title: '¿Qué puedo encontrar en The Achievery?', duration: '1:49', platform: 'The Achievery', type: 'jwplayer', videoId: '1pLZjw7V' },
      { id: 'meet-career-village', title: 'Conoce Career Village', duration: '2:07', platform: 'Career Village', type: 'jwplayer', videoId: 'r8MooNXN' }
    ],
    // Orden espejado con el inglés (en el doc de contenido, ES tenía 4 y 5 invertidas).
    faqs: [
      {
        q: '¿Qué es un Connected Learning Center (CLC)?',
        a: 'Un Connected Learning Center es un espacio comunitario gratuito organizado por instituciones locales en alianza con AT&amp;T que ofrece internet de alta velocidad, computadoras modernas y capacitación en habilidades digitales para ayudar a estudiantes, adultos, cuidadores y adultos mayores a desenvolverse en el mundo digital de hoy.'
      },
      {
        q: '¿Quién puede usar un Connected Learning Center?',
        a: 'Los CLCs están abiertos a todos en la comunidad de forma gratuita. Ya seas un estudiante haciendo la tarea, un adulto desarrollando nuevas habilidades laborales, o alguien que está aprendiendo a usar un smartphone por primera vez, hay un lugar para ti.'
      },
      {
        q: '¿Qué tipo de recursos están disponibles en un CLC?',
        a: 'Cada centro ofrece internet de alta velocidad, acceso a dispositivos modernos y capacitación práctica en habilidades digitales, desde el uso básico del smartphone hasta habilidades esenciales de computación.'
      },
      {
        q: '¿Dónde puedo encontrar más información o ubicar el CLC más cercano?',
        a: 'Visita <a href="https://sustainability.att.com/cr/cl-centers" target="_blank" rel="noopener noreferrer">sustainability.att.com/cr/cl-centers</a> para encontrar el Connected Learning Center más cercano, junto con horarios, datos de contacto y programas disponibles.'
      },
      {
        q: '¿A qué plataformas de aprendizaje puedo acceder en un CLC?',
        a: 'Según tu necesidad, puedes comenzar con:'
          + '<ul>'
          + '<li><strong>ScreenReady®</strong> - recursos para padres y cuidadores sobre seguridad y habilidades digitales</li>'
          + '<li><strong>The Achievery</strong> - plataforma de aprendizaje para estudiantes de K-12</li>'
          + '<li><strong>CareerVillage</strong> - mentoría vocacional para estudiantes de secundaria y universidad</li>'
          + '</ul>'
      },
      {
        q: '¿Cómo puedo mantenerme al tanto de todas las novedades de los CLC?',
        a: '¡Es muy fácil! Solo tienes que ir a la sección “Mantente al día”, ingresar tu correo electrónico, seleccionar tu centro y hacer clic en Suscribirme. Vas a recibir todas las novedades relevantes: invitaciones, recursos y más, directo en tu casilla de correo.'
      },
      {
        q: '¿Qué es ScreenReady?',
        a: 'ScreenReady es una iniciativa de AT&amp;T enfocada en el bienestar digital familiar, que brinda recursos, tips y herramientas para ayudarte a ti y a tu familia a generar confianza en el uso de la tecnología, practicar hábitos digitales saludables y participar plenamente en el mundo conectado de hoy.'
      }
    ]
  }
};
